import { BsModalRef, ModalDirective } from 'ngx-bootstrap/modal';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

import { BranchDetail } from './../../interfaces/branch';
import { DataMappingService } from './../../services/data-mapping.service';
import { JsonDataService } from './../../services/json-data.service';
import { PetService } from '../../services/pet.service'
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead';
import { UserDetail } from './../../interfaces/user';
import { UserPermission } from '../../interfaces/user';
import { QRCodeDetail } from '../../interfaces/qr-code';

@Component({
  selector: 'app-user-detail',
  templateUrl: './user-detail.component.html',
  styleUrls: ['./user-detail.component.scss']
})
export class UserDetailComponent implements OnInit {
  selectedUser = {} as UserDetail;
  public userDetailForm: FormGroup;
  isLoading = false;
  userUpdateData = new FormData();
  isSavingUser = false;
  public onClose= new Subject<boolean>();
  isBranchesLoaded = false;
  branchesList = [] as BranchDetail[];
  selectedBranch = {} as BranchDetail;
  permissions = [] as UserPermission[];
  selectedPermissions: string[] = [];
  hasEditPermission: boolean = false;
  hasAddPermission: boolean = false;
  hasViewPermission: boolean = false;
  hasEditUserPermissionPermission: boolean = false;

  constructor(private formBuilder: FormBuilder,
    private petService: PetService,
    private router: Router,
    public bsModalRef: BsModalRef,
    private dataMappingService: DataMappingService,
    private jsonDataService: JsonDataService,
  ) {

    this.petService.loadPermissions().subscribe({
      next: (response) => {
        console.log(`constructor, loadPermissions response: ${JSON.stringify(response)}`);
        this.permissions = response;
      },
      error: (error) => {
        console.error(`loadPermissions, error: ${JSON.stringify(error)}`);
      }
    });

    this.userDetailForm = this.formBuilder.group({
      branch: ['', [Validators.required]],
      username: ['', [Validators.required]],
      firstName: ['', [Validators.required]],
      lastName: ['', [Validators.required]],
      email: ['', [Validators.required]],
      isViewNumberOfOwners: ['', []],
      isViewNumberOfPets: ['', []],
      isViewNumberOfCheckIns: ['', []],
      //isViewNumberOfCheckInPets: ['', []],
      isViewNumberOfRegistrations: ['', []],
      isViewTotalRevenue: ['', []],
      isViewDashboard: ['', []],
      isViewTotalExpense: ['', []],
      isViewTotalIncome: ['', []],
      isViewMonthlyRevenue: ['', []],
      isViewMonthlyExpense: ['', []],
      isViewMonthlyIncome: ['', []],
      isViewCurrentYearMonthlyRevenue: ['', []],
      isViewCurrentYearMonthlyExpense: ['', []],
      isViewCurrentYearMonthlyIncome: ['', []],
      isViewPetList: ['', []],
      isAddPet: ['', []],
      isViewPetDetail: ['', []],
      isUpdatePetDetail: ['', []],
      isViewOwnerList: ['', []],
      isAddOwner: ['', []],
      isViewOwnerDetail: ['', []],
      isUpdateOwnerDetail: ['', []],
      isViewPickUpList: ['', []],
      isAddPickUp: ['', []],
      isViewPickUpDetail: ['', []],
      isUpdatePickUpDetail: ['', []],
      isViewCheckInList: ['', []],
      isAddCheckIn: ['', []],
      isViewCheckInDetail: ['', []],
      isUpdateCheckInDetail: ['', []],
      isViewCheckOutList: ['', []],
      isAddCheckOut: ['', []],
      isViewCheckOutDetail: ['', []],
      isUpdateCheckOutDetail: ['', []],
      isViewInvoiceList: ['', []],
      isAddInvoice: ['', []],
      isViewInvoiceDetail: ['', []],
      isUpdateInvoiceDetail: ['', []],
      isViewExpenseList: ['', []],
      isAddExpense: ['', []],
      isViewExpenseDetail: ['', []],
      isUpdateExpenseDetail: ['', []],
      isViewUserList: ['', []],
      isAddUser: ['', []],
      isViewUserDetail: ['', []],
      isUpdateUserDetail: ['', []],
      isUpdateUserPermission: ['', []],
      isViewQRCodeList: [false],
      isAddQRCode: [false],
      isViewQRCodeDetail: [false],
      isUpdateQRCodeDetail: [false],
      
      // isViewTotal: ['', []],
      // permissions: this.formBuilder.group(
      //   this.permissions.reduce((acc, permission) => {
      //     acc[permission.codename] = new FormControl(false); // Default to unchecked
      //     return acc;
      //   }, {} as { [key: string]: FormControl })
      // )
    });
  }

  ngOnInit(): void {
    this.checkPermissions();
    this.getBranches();

    console.log(`UserDetailComponent, ngOnInit, This is user detail modal`);
    console.log(`UserDetailComponent, selectedUser: ${JSON.stringify(this.selectedUser)}`);
    if (this.selectedUser) {
      this.disableField('username');
      this.selectedBranch = this.selectedUser.branch
      this.patchUserDetailForm(this.selectedUser);
      if(!this.hasEditPermission) {
        this.disableUserDetailsFields();
      }

      const currentUser = this.petService.getCurrentUser();
      console.log(`UserDetailComponent, currentUser: ${JSON.stringify(currentUser)}`);
      console.log(`UserDetailComponent, selectedUser Id: ${this.selectedUser.id}, current user Id: ${currentUser.id}`);
      if(!this.hasEditUserPermissionPermission || this.selectedUser.id == currentUser?.id) {
        this.disableUserPermissionFields();
      }
    }
    else {
      if(!this.hasAddPermission) {
        this.disableForm();
      }
    }

    this.setFormFieldsSelectedValue();
  }

  setFormFieldsSelectedValue() {
    this.userDetailForm.get('branch')?.valueChanges.subscribe(value => {
      console.log(`branch chang, value: ${JSON.stringify(value)}`);
      this.selectedBranch = value;
      console.log(`userDetailForm chang, value: ${value}, selectedBranch: ${JSON.stringify(this.selectedBranch)}`);
    });
  }

  getBranches() {
    this.isBranchesLoaded = false;
    this.petService.getBranches().subscribe({
      next: (response) => {
        console.log(`getBranches, response: ${JSON.stringify(response)}`);
        this.branchesList = response;
        this.selectedBranch = this.branchesList.filter(b => b.id==this.selectedUser.branch.id)[0];
        console.log(`getBranches, selectedBranch: ${JSON.stringify(this.selectedBranch)}`);
        this.userDetailForm.get('branch')?.setValue(this.selectedBranch);
        this.isBranchesLoaded = true;
      },
      error: (error) => {
        this.isBranchesLoaded = true;
        console.error(`getBranches, error: ${JSON.stringify(error)}`);
      }
    });
  } // end of getBranches

  patchUserDetailForm(user: UserDetail) {
    this.userDetailForm.patchValue(user);
    this.userDetailForm.controls['branch'].setValue(user.branch.name);
    // var viewNumberOfOwners = user.userPermissions.find(p => p.codename=="view_dashboard_number_of_owners") !=null ? true : false;
    // this.userDetailForm.controls['isViewNumberOfOwners'].setValue(viewNumberOfOwners);

    // var viewNumberOfPets = user.userPermissions.find(p => p.codename=="view_dashboard_number_of_pets") !=null ? true : false;
    // this.userDetailForm.controls['isViewNumberOfPets'].setValue(viewNumberOfPets);
    // Patching user permissions to permission checkboxes
    this.patchUserPermissions(user);
  } // end of patchUserDetailForm

  patchUserPermissions(user: UserDetail) {
    this.patchUserDashboardPermissions(user);
    this.patchUserPetPermissions(user);
    this.patchUserOwnerPermissions(user);
    this.patchUserCheckInPermissions(user);
    this.patchUserCheckOutPermissions(user);
    this.patchUserPickUpPermissions(user);
    this.patchUserInvoicePermissions(user);
    this.patchUserExpensePermissions(user);
    this.patchUserUserPermissions(user);
    this.patchUserQRCodePermissions(user);
  } // end of patchUserPermissions

  patchUserDashboardPermissions(user: UserDetail) {
    // View dashboard
    var isViewDashboard = user.userPermissions.find(p => p.codename=="view_dashboard") !=null ? true : false;
    this.userDetailForm.controls['isViewDashboard'].setValue(isViewDashboard);

    // View number of owners
    var viewNumberOfOwners = user.userPermissions.find(p => p.codename=="view_dashboard_number_of_owners") !=null ? true : false;
    this.userDetailForm.controls['isViewNumberOfOwners'].setValue(viewNumberOfOwners);
    // View number of pets
    var viewNumberOfPets = user.userPermissions.find(p => p.codename=="view_dashboard_number_of_pets") !=null ? true : false;
    this.userDetailForm.controls['isViewNumberOfPets'].setValue(viewNumberOfPets);
    // View number of check-ins
    var isViewNumberOfCheckIns = user.userPermissions.find(p => p.codename=="view_dashboard_number_of_check_ins") !=null ? true : false;
    this.userDetailForm.controls['isViewNumberOfCheckIns'].setValue(isViewNumberOfCheckIns);
    // View number of check-in pets
    // var isViewNumberOfCheckInPets = user.userPermissions.find(p => p.codename=="view_dashboard_number_of_check_in_pets") !=null ? true : false;
    // this.userDetailForm.controls['isViewNumberOfCheckInPets'].setValue(isViewNumberOfCheckInPets);
    // View number of registrations
    var isViewNumberOfRegistrations = user.userPermissions.find(p => p.codename=="view_dashboard_number_of_registrations") !=null ? true : false;
    this.userDetailForm.controls['isViewNumberOfRegistrations'].setValue(isViewNumberOfRegistrations);
    // View total revenue
    var isViewTotalRevenue = user.userPermissions.find(p => p.codename=="view_dashboard_total_revenue") !=null ? true : false;
    this.userDetailForm.controls['isViewTotalRevenue'].setValue(isViewTotalRevenue);
    // View total expense
    var isViewTotalExpense = user.userPermissions.find(p => p.codename=="view_dashboard_total_expense") !=null ? true : false;
    this.userDetailForm.controls['isViewTotalExpense'].setValue(isViewTotalExpense);
    // View total income
    var isViewTotalIncome = user.userPermissions.find(p => p.codename=="view_dashboard_total_income") !=null ? true : false;
    this.userDetailForm.controls['isViewTotalIncome'].setValue(isViewTotalIncome);
    // View monthly revenue
    var isViewMonthlyRevenue = user.userPermissions.find(p => p.codename=="view_dashboard_monthly_revenue") !=null ? true : false;
    this.userDetailForm.controls['isViewMonthlyRevenue'].setValue(isViewMonthlyRevenue);
    // View monthly expense
    var isViewMonthlyExpense = user.userPermissions.find(p => p.codename=="view_dashboard_monthly_expense") !=null ? true : false;
    this.userDetailForm.controls['isViewMonthlyExpense'].setValue(isViewMonthlyExpense);
    // View monthly income
    var isViewMonthlyIncome = user.userPermissions.find(p => p.codename=="view_dashboard_monthly_income") !=null ? true : false;
    this.userDetailForm.controls['isViewMonthlyIncome'].setValue(isViewMonthlyIncome);
     // View current year monthly revenue
     var isViewCurrentYearMonthlyRevenue = user.userPermissions.find(p => p.codename=="view_dashboard_current_year_monthly_revenue") !=null ? true : false;
     this.userDetailForm.controls['isViewCurrentYearMonthlyRevenue'].setValue(isViewCurrentYearMonthlyRevenue);
     // View current year monthly expense
     var isViewCurrentYearMonthlyExpense = user.userPermissions.find(p => p.codename=="view_dashboard_current_year_monthly_expense") !=null ? true : false;
     this.userDetailForm.controls['isViewCurrentYearMonthlyExpense'].setValue(isViewCurrentYearMonthlyExpense);
     // View current year monthly income
     var isViewCurrentYearMonthlyIncome = user.userPermissions.find(p => p.codename=="view_dashboard_current_year_monthly_income") !=null ? true : false;
     this.userDetailForm.controls['isViewCurrentYearMonthlyIncome'].setValue(isViewCurrentYearMonthlyIncome);
  } // end of patchUserDashboardPermissions

  patchUserPetPermissions(user: UserDetail) {
    // View pets list
    var isViewPetList = user.userPermissions.find(p => p.codename=="view_pet_list") !=null ? true : false;
    this.userDetailForm.controls['isViewPetList'].setValue(isViewPetList);
    // Add pet
    var isAddPet = user.userPermissions.find(p => p.codename=="add_pet") !=null ? true : false;
    this.userDetailForm.controls['isAddPet'].setValue(isAddPet);
    // View pet details
    var isViewPetDetail = user.userPermissions.find(p => p.codename=="view_pet") !=null ? true : false;
    this.userDetailForm.controls['isViewPetDetail'].setValue(isViewPetDetail);
    // Update pet details
    var isUpdatePetDetail = user.userPermissions.find(p => p.codename=="change_pet") !=null ? true : false;
    this.userDetailForm.controls['isUpdatePetDetail'].setValue(isUpdatePetDetail);
  } // end of patchUserPetPermissions

  patchUserOwnerPermissions(user: UserDetail) {
    // View owner list
    var isViewOwnerList = user.userPermissions.find(p => p.codename=="view_owner_list") !=null ? true : false;
    this.userDetailForm.controls['isViewOwnerList'].setValue(isViewOwnerList);
    // Add owner
    var isAddOwner = user.userPermissions.find(p => p.codename=="add_owner") !=null ? true : false;
    this.userDetailForm.controls['isAddOwner'].setValue(isAddOwner);
    // View owner details
    var isViewOwnerDetail = user.userPermissions.find(p => p.codename=="view_owner") !=null ? true : false;
    this.userDetailForm.controls['isViewOwnerDetail'].setValue(isViewOwnerDetail);
    // Update owner details
    var isUpdateOwnerDetail = user.userPermissions.find(p => p.codename=="change_owner") !=null ? true : false;
    this.userDetailForm.controls['isUpdateOwnerDetail'].setValue(isUpdateOwnerDetail);
  } // end of patchUserOwnerPermissions

  patchUserPickUpPermissions(user: UserDetail) {
    // View Check-out list
    var isViewPickUpList = user.userPermissions.find(p => p.codename=="view_pickup_list") != null ? true : false;
    this.userDetailForm.controls['isViewPickUpList'].setValue(isViewPickUpList);
    // Add Check-out
    var isAddPickUp = user.userPermissions.find(p => p.codename=="add_pickup") != null ? true : false;
    this.userDetailForm.controls['isAddPickUp'].setValue(isAddPickUp);
    // View Check-out details
    var isViewPickUpDetail = user.userPermissions.find(p => p.codename=="view_pickup") != null ? true : false;
    this.userDetailForm.controls['isViewPickUpDetail'].setValue(isViewPickUpDetail);
    // Update Check-out details
    var isUpdatePickUpDetail = user.userPermissions.find(p => p.codename=="change_pickup") != null ? true : false;
    this.userDetailForm.controls['isUpdatePickUpDetail'].setValue(isUpdatePickUpDetail);
  } // end of patchUserPickUpPermissions

  patchUserCheckInPermissions(user: UserDetail) {
    // View Check-in list
    var isViewCheckInList = user.userPermissions.find(p => p.codename=="view_checkin_list") !=null ? true : false;
    this.userDetailForm.controls['isViewCheckInList'].setValue(isViewCheckInList);
    // Add Check-in
    var isAddCheckIn = user.userPermissions.find(p => p.codename=="add_checkin") !=null ? true : false;
    this.userDetailForm.controls['isAddCheckIn'].setValue(isAddCheckIn);
    // View Check-in details
    var isViewCheckInDetail = user.userPermissions.find(p => p.codename=="view_checkin") !=null ? true : false;
    this.userDetailForm.controls['isViewCheckInDetail'].setValue(isViewCheckInDetail);
    // Update Check-in details
    var isUpdateCheckInDetail = user.userPermissions.find(p => p.codename=="change_checkin") !=null ? true : false;
    this.userDetailForm.controls['isUpdateCheckInDetail'].setValue(isUpdateCheckInDetail);
  } // end of patchUserCheckInPermissions

  patchUserCheckOutPermissions(user: UserDetail) {
    // View Check-out list
    var isViewCheckOutList = user.userPermissions.find(p => p.codename=="view_checkout_list") != null ? true : false;
    this.userDetailForm.controls['isViewCheckOutList'].setValue(isViewCheckOutList);
    // Add Check-out
    var isAddCheckOut = user.userPermissions.find(p => p.codename=="add_checkout") != null ? true : false;
    this.userDetailForm.controls['isAddCheckOut'].setValue(isAddCheckOut);
    // View Check-out details
    var isViewCheckOutDetail = user.userPermissions.find(p => p.codename=="view_checkout") != null ? true : false;
    this.userDetailForm.controls['isViewCheckOutDetail'].setValue(isViewCheckOutDetail);
    // Update Check-out details
    var isUpdateCheckOutDetail = user.userPermissions.find(p => p.codename=="change_checkout") != null ? true : false;
    this.userDetailForm.controls['isUpdateCheckOutDetail'].setValue(isUpdateCheckOutDetail);
  } // end of patchUserCheckOutPermissions

  patchUserInvoicePermissions(user: UserDetail) {
    // View Check-out list
    var isViewInvoiceList = user.userPermissions.find(p => p.codename=="view_invoice_list") != null ? true : false;
    this.userDetailForm.controls['isViewInvoiceList'].setValue(isViewInvoiceList);
    // Add Check-out
    var isAddInvoice = user.userPermissions.find(p => p.codename=="add_invoice") != null ? true : false;
    this.userDetailForm.controls['isAddInvoice'].setValue(isAddInvoice);
    // View Check-out details
    var isViewInvoiceDetail = user.userPermissions.find(p => p.codename=="view_invoice") != null ? true : false;
    this.userDetailForm.controls['isViewInvoiceDetail'].setValue(isViewInvoiceDetail);
    // Update Check-out details
    var isUpdateInvoiceDetail = user.userPermissions.find(p => p.codename=="change_invoice") != null ? true : false;
    this.userDetailForm.controls['isUpdateInvoiceDetail'].setValue(isUpdateInvoiceDetail);
  } // end of patchUserPickUpPermissions

  patchUserExpensePermissions(user: UserDetail) {
    // View Check-out list
    var isViewExpenseList = user.userPermissions.find(p => p.codename=="view_expense_list") != null ? true : false;
    this.userDetailForm.controls['isViewExpenseList'].setValue(isViewExpenseList);
    // Add Check-out
    var isAddExpense = user.userPermissions.find(p => p.codename=="add_expense") != null ? true : false;
    this.userDetailForm.controls['isAddExpense'].setValue(isAddExpense);
    // View Check-out details
    var isViewExpenseDetail = user.userPermissions.find(p => p.codename=="view_expense") != null ? true : false;
    this.userDetailForm.controls['isViewExpenseDetail'].setValue(isViewExpenseDetail);
    // Update Check-out details
    var isUpdateExpenseDetail = user.userPermissions.find(p => p.codename=="change_expense") != null ? true : false;
    this.userDetailForm.controls['isUpdateExpenseDetail'].setValue(isUpdateExpenseDetail);
  } // end of patchUserPickUpPermissions

  patchUserUserPermissions(user: UserDetail) {
    // View user list
    var isViewUserList = user.userPermissions.find(p => p.codename=="view_user_list") != null ? true : false;
    this.userDetailForm.controls['isViewUserList'].setValue(isViewUserList);
    // Add User
    var isAddUser = user.userPermissions.find(p => p.codename=="add_user") != null ? true : false;
    this.userDetailForm.controls['isAddUser'].setValue(isAddUser);
    // View user details
    var isViewUserDetail = user.userPermissions.find(p => p.codename=="view_user") != null ? true : false;
    this.userDetailForm.controls['isViewUserDetail'].setValue(isViewUserDetail);
    // Update user details
    var isUpdateUserDetail = user.userPermissions.find(p => p.codename=="change_user") != null ? true : false;
    this.userDetailForm.controls['isUpdateUserDetail'].setValue(isUpdateUserDetail);

    // Update user permission
    var isUpdateUserPermission = user.userPermissions.find(p => p.codename=="change_user_permission") != null ? true : false;
    this.userDetailForm.controls['isUpdateUserPermission'].setValue(isUpdateUserPermission);
  } // end of patchUserUserPermissions

  patchUserQRCodePermissions(user: UserDetail) {
    // View QR code list
    var isViewQRCodeList = user.userPermissions.find(p => p.codename=="view_qrcode_list") != null ? true : false;
    this.userDetailForm.controls['isViewQRCodeList'].setValue(isViewQRCodeList);
    // Add QR code
    var isAddQRCode = user.userPermissions.find(p => p.codename=="add_qrcode") != null ? true : false;
    this.userDetailForm.controls['isAddQRCode'].setValue(isAddQRCode);
    // View QR code details
    var isViewQRCodeDetail = user.userPermissions.find(p => p.codename=="view_qrcode") != null ? true : false;
    this.userDetailForm.controls['isViewQRCodeDetail'].setValue(isViewQRCodeDetail);
    // Update QR code details
    var isUpdateQRCodeDetail = user.userPermissions.find(p => p.codename=="change_qrcode") != null ? true : false;
    this.userDetailForm.controls['isUpdateQRCodeDetail'].setValue(isUpdateQRCodeDetail);
  } // end of patchUserQRCodePermissions

  saveUser() {
    this.updateUser();
  } // end of saveUser

  updateUser() {
    this.isSavingUser = true;
    this.createUserUpdatePayload();
    console.log(`updateUser, userUpdateData:${JSON.stringify(this.userUpdateData)}`);
    this.petService.updateUser(this.selectedUser.id, this.userUpdateData).subscribe({
      next: (response) => {
        this.isSavingUser = false;
        console.log(`updateUser, response: ${JSON.stringify(response)}`);
        this.hideModal(true);
        this.router.navigate(['user']);
      },
      error: (error) => {
        this.isSavingUser = false;
        console.error(`updateUser, error: ${JSON.stringify(error)}`);
      }
    });
    this.isSavingUser = false;
  } // end of updateUser

  createUserUpdatePayload() {
    const formValues = this.userDetailForm.value;
    console.log(`createUserUpdatePayload, formValues: ${JSON.stringify(formValues)}`);

    this.createUserDetailsUpdatePayload(formValues);
    this.createUserPermissionsUpdatePayload(formValues);
  }  // end of createUserUpdatePayload

  createUserDetailsUpdatePayload(formValues: any) {
    //const formValues = this.userDetailForm.value;
    console.log(`createUserUpdatePayload, formValues: ${JSON.stringify(formValues)}`);

    //this.userUpdateData.append('username', this.selectedUser.username);
    this.userUpdateData.append('first_name', formValues.firstName);
    this.userUpdateData.append('last_name', formValues.lastName);
    this.userUpdateData.append('email', formValues.email);
    this.userUpdateData.append("branch_id", this.selectedBranch.id);
  }  // end of createUserUpdatePayload


  createUserPermissionsUpdatePayload(formValues: any) {
    this.createUserDashboardPermissionsUpdatePayload(formValues);
    this.createUserPetPermissionsUpdatePayload(formValues);
    this.createUserOwnerPermissionsUpdatePayload(formValues);
    this.createUserCheckInPermissionsUpdatePayload(formValues);
    this.createUserCheckOutPermissionsUpdatePayload(formValues);
    this.createUserPickUpPermissionsUpdatePayload(formValues);
    this.createUserInvoicePermissionsUpdatePayload(formValues);
    this.createUserExpensePermissionsUpdatePayload(formValues);
    this.createUserUserPermissionsUpdatePayload(formValues);
    this.createUserQRCodePermissionsUpdatePayload(formValues);

    this.selectedPermissions.forEach((permission, index) => {
      this.userUpdateData.append(`permissions[${index}]`, permission);
    });
  }​ // end of createUserPermissionsUpdatePayload

  createUserDashboardPermissionsUpdatePayload(formValues: any) {
    console.log(`createUserDashboardPermissionsUpdatePayload, formValues: ${JSON.stringify(formValues)}`);
    console.log(`createUserDashboardPermissionsUpdatePayload, isViewNumberOfOwners: ${formValues.isViewNumberOfOwners}`);
    console.log(`createUserDashboardPermissionsUpdatePayload, before adding item, permissions length: ${this.selectedPermissions.length}`);

    var isViewDashboardPermission = false;
    var isPermission = false;
    
    isPermission = formValues.isViewNumberOfOwners;
    console.log(`createUserDashboardPermissionsUpdatePayload, isViewNumberOfOwners: ${isPermission}`);    
    if (isPermission) {
      this.selectedPermissions.push("view_dashboard_number_of_owners");
      var isViewDashboardPermission = true;
    }

    isPermission = formValues.isViewNumberOfPets;
    console.log(`createUserDashboardPermissionsUpdatePayload, isViewNumberOfPets: ${isPermission}`);
    
    if (isPermission) {
      this.selectedPermissions.push("view_dashboard_number_of_pets");
      var isViewDashboardPermission = true;
    }

    isPermission = formValues.isViewNumberOfCheckIns;
    console.log(`createUserDashboardPermissionsUpdatePayload, isViewNumberOfCheckIns: ${isPermission}`);
    if (isPermission) {
      this.selectedPermissions.push("view_dashboard_number_of_check_ins");
      var isViewDashboardPermission = true;
    }

    isPermission = formValues.isViewNumberOfRegistrations;
    console.log(`createUserDashboardPermissionsUpdatePayload, isViewNumberOfRegistrations: ${isPermission}`);
    if (isPermission) {
      this.selectedPermissions.push("view_dashboard_number_of_registrations");
      var isViewDashboardPermission = true;
    }

    isPermission = formValues.isViewTotalIncome;
    console.log(`createUserDashboardPermissionsUpdatePayload, isViewTotalIncome: ${isPermission}`);
    if (isPermission) {
      this.selectedPermissions.push("view_dashboard_total_revenue");
      var isViewDashboardPermission = true;
    }

    isPermission = formValues.isViewTotalExpense;
    console.log(`createUserDashboardPermissionsUpdatePayload, isViewTotalExpense: ${isPermission}`);
    if (isPermission) {
      this.selectedPermissions.push("view_dashboard_total_income");
      var isViewPetPagePermission = true;
    }

    isPermission = formValues.isViewTotalRevenue;
    console.log(`createUserDashboardPermissionsUpdatePayload, isViewTotalRevenue: ${isPermission}`);
    if (isPermission) {
      this.selectedPermissions.push("view_dashboard_total_expense");
      var isViewDashboardPermission = true;
    }

    isPermission = formValues.isViewMonthlyIncome;
    console.log(`createUserDashboardPermissionsUpdatePayload, isViewMonthlyIncome: ${isPermission}`);
    if (isPermission) {
      this.selectedPermissions.push("view_dashboard_monthly_income");
      var isViewDashboardPermission = true;
    }

    isPermission = formValues.isViewMonthlyExpense;
    console.log(`createUserDashboardPermissionsUpdatePayload, isViewMonthlyExpense: ${isPermission}`);
    if (isPermission) {
      this.selectedPermissions.push("view_dashboard_monthly_expense");
      var isViewDashboardPermission = true;
    }

    isPermission = formValues.isViewMonthlyRevenue;
    console.log(`createUserDashboardPermissionsUpdatePayload, isViewMonthlyRevenue: ${isPermission}`);
    if (isPermission) {
      this.selectedPermissions.push("view_dashboard_monthly_revenue");
      var isViewDashboardPermission = true;
    }

    isPermission = formValues.isViewCurrentYearMonthlyIncome;
    console.log(`createUserDashboardPermissionsUpdatePayload, isViewCurrentYearMonthlyIncome: ${isPermission}`);
    if (isPermission) {
      this.selectedPermissions.push("view_dashboard_current_year_monthly_income");
      var isViewDashboardPermission = true;
    }

    isPermission = formValues.isViewCurrentYearMonthlyExpense;
    console.log(`createUserDashboardPermissionsUpdatePayload, isViewCurrentYearMonthlyExpense: ${isPermission}`);
    if (isPermission) {
      this.selectedPermissions.push("view_dashboard_current_year_monthly_expense");
      var isViewDashboardPermission = true;
    }

    isPermission = formValues.isViewCurrentYearMonthlyRevenue;
    console.log(`createUserDashboardPermissionsUpdatePayload, isViewCurrentYearMonthlyRevenue: ${isPermission}`);
    if (isPermission) {
      this.selectedPermissions.push("view_dashboard_current_year_monthly_revenue");
      var isViewDashboardPermission = true;
    }

    if (isViewDashboardPermission) {
      this.selectedPermissions.push("view_dashboard");
    }
    console.log(`createUserDashboardPermissionsUpdatePayload, permissions: ${JSON.stringify(this.permissions)}`);
    console.log(`createUserDashboardPermissionsUpdatePayload, after adding item, permissions length: ${this.permissions.length}`);
  }  // end of createUserDashboardPermissionsUpdatePayload

  createUserPetPermissionsUpdatePayload(formValues: any) {
    var isViewPetPagePermission = false;
    var isPermission = false; 
    isPermission = formValues.isViewPetList;
    console.log(`createUserPetPermissionsUpdatePayload, isViewPetList: ${isPermission}`);
    if (isPermission) {
      this.selectedPermissions.push("view_pet_list");
      isViewPetPagePermission = true;
    }

    isPermission = formValues.isAddPet;
    console.log(`createUserPetPermissionsUpdatePayload, isAddPet: ${isPermission}`);
    if (isPermission) {
      this.selectedPermissions.push("add_pet");
      isViewPetPagePermission = true;
    }

    isPermission = formValues.isViewPetDetail;
    console.log(`createUserPetPermissionsUpdatePayload, isViewPetDetail: ${isPermission}`);
    if (isPermission) {
      this.selectedPermissions.push("view_pet");
      isViewPetPagePermission = true;
    }

    isPermission = formValues.isUpdatePetDetail;
    console.log(`createUserPetPermissionsUpdatePayload, isUpdatePetDetail: ${isPermission}`);
    if (isPermission) {
      this.selectedPermissions.push("change_pet");
      isViewPetPagePermission = true;
    }

    if (isViewPetPagePermission) {
      this.selectedPermissions.push("view_pet_page");
    }

    console.log(`createUserPetPermissionsUpdatePayload, permissions: ${JSON.stringify(this.selectedPermissions)}`);
    console.log(`createUserPetPermissionsUpdatePayload, after adding item, permissions length: ${this.selectedPermissions.length}`);

    // this.selectedPermissions.forEach((permission, index) => {
    //   this.userUpdateData.append(`permissions[${index}]`, permission);
    // });

    //this.userUpdateData.append('permissions', permissions);

    console.log(`createUserPetPermissionsUpdatePayload, permissions: ${JSON.stringify(this.userUpdateData.get("permissions"))}`);
  }  // end of createUserPetPermissionsUpdatePayload

  createUserOwnerPermissionsUpdatePayload(formValues: any) {
    var isViewOwnerPagePermission = false;
    var isPermission = false; 
    isPermission = formValues.isViewOwnerList;
    console.log(`createUserOwnerPermissionsUpdatePayload, isViewOwnerList: ${isPermission}`);
    if (isPermission) {
      this.selectedPermissions.push("view_owner_list");
      isViewOwnerPagePermission = true;
    }

    isPermission = formValues.isAddOwner;
    console.log(`createUserOwnerPermissionsUpdatePayload, isAddOwner: ${isPermission}`);
    if (isPermission) {
      this.selectedPermissions.push("add_owner");
      isViewOwnerPagePermission = true;
    }

    isPermission = formValues.isViewOwnerDetail;
    console.log(`createUserOwnerPermissionsUpdatePayload, isViewOwnerDetail: ${isPermission}`);
    if (isPermission) {
      this.selectedPermissions.push("view_owner");
      isViewOwnerPagePermission = true;
    }

    isPermission = formValues.isUpdateOwnerDetail;
    console.log(`createUserOwnerPermissionsUpdatePayload, isUpdateOwnerDetail: ${isPermission}`);
    if (isPermission) {
      this.selectedPermissions.push("change_owner");
      isViewOwnerPagePermission = true;
    }

    if (isViewOwnerPagePermission) {
      this.selectedPermissions.push("view_owner_page");
    }

    console.log(`createUserOwnerPermissionsUpdatePayload, permissions: ${JSON.stringify(this.selectedPermissions)}`);
    console.log(`createUserOwnerPermissionsUpdatePayload, after adding item, permissions length: ${this.selectedPermissions.length}`);
  }  // end of createUserOwnerPermissionsUpdatePayload

  // createUserOwnerPermissionsUpdatePayload(formValues: any) {
  //   var isPermission = false; 
  //   isPermission = formValues.isViewcheckinList;
  //   console.log(`createUsercheckinPermissionsUpdatePayload, isViewcheckinList: ${isPermission}`);
  //   if (isPermission) {
  //     this.selectedPermissions.push("view_owner_list");
  //   }

  //   isPermission = formValues.isAddcheckin;
  //   console.log(`createUsercheckinPermissionsUpdatePayload, isAddcheckin: ${isPermission}`);
  //   if (isPermission) {
  //     this.selectedPermissions.push("add_owner");
  //   }

  //   isPermission = formValues.isViewCheckInDetail;
  //   console.log(`createUserCheckInPermissionsUpdatePayload, isViewCheckInDetail: ${isPermission}`);
  //   if (isPermission) {
  //     this.selectedPermissions.push("view_owner");
  //   }

  //   isPermission = formValues.isUpdateCheckInDetail;
  //   console.log(`createUserCheckInPermissionsUpdatePayload, isUpdateCheckInDetail: ${isPermission}`);
  //   if (isPermission) {
  //     this.selectedPermissions.push("change_owner");
  //   }

  //   console.log(`createUserCheckInPermissionsUpdatePayload, permissions: ${JSON.stringify(this.selectedPermissions)}`);
  //   console.log(`createUserCheckInPermissionsUpdatePayload, after adding item, permissions length: ${this.selectedPermissions.length}`);
  // }  // end of createUserCheckInPermissionsUpdatePayload

  createUserPickUpPermissionsUpdatePayload(formValues: any) {
    var isViewPickUpPagePermission = false;
    var isPermission = false; 
    isPermission = formValues.isViewPickUpList;
    console.log(`createUserPickUpPermissionsUpdatePayload, isViewPickUpList: ${isPermission}`);
    if (isPermission) {
      this.selectedPermissions.push("view_pickup_list");
    }

    isPermission = formValues.isAddPickUp;
    console.log(`createUserPickUpPermissionsUpdatePayload, isAddPickUp: ${isPermission}`);
    if (isPermission) {
      this.selectedPermissions.push("add_pickup");
      isViewPickUpPagePermission = true;
    }

    isPermission = formValues.isViewPickUpDetail;
    console.log(`createUserPickUpPermissionsUpdatePayload, isViewPickUpDetail: ${isPermission}`);
    if (isPermission) {
      this.selectedPermissions.push("view_pickup");
      isViewPickUpPagePermission = true;
    }

    isPermission = formValues.isUpdatePickUpDetail;
    console.log(`createUserPickUpPermissionsUpdatePayload, isUpdatePickUpDetail: ${isPermission}`);
    if (isPermission) {
      this.selectedPermissions.push("change_pickup");
      isViewPickUpPagePermission = true;
    }

    if (isViewPickUpPagePermission) {
      this.selectedPermissions.push("view_pickup_page");
    }

    console.log(`createUserPickUpPermissionsUpdatePayload, permissions: ${JSON.stringify(this.selectedPermissions)}`);
    console.log(`createUserPickUpPermissionsUpdatePayload, after adding item, permissions length: ${this.selectedPermissions.length}`);
  }  // end of createUserPickUpPermissionsUpdatePayload

  createUserCheckInPermissionsUpdatePayload(formValues: any) {
    var isViewCheckInPagePermission = false;
    var isPermission = false; 
    isPermission = formValues.isViewCheckInList;
    console.log(`createUserCheckInPermissionsUpdatePayload, isViewCheckInList: ${isPermission}`);
    if (isPermission) {
      this.selectedPermissions.push("view_checkin_list");
    }

    isPermission = formValues.isAddCheckIn;
    console.log(`createUserCheckInPermissionsUpdatePayload, isAddCheckIn: ${isPermission}`);
    if (isPermission) {
      this.selectedPermissions.push("add_checkin");
      isViewCheckInPagePermission = true;
    }

    isPermission = formValues.isViewCheckInDetail;
    console.log(`createUserCheckInPermissionsUpdatePayload, isViewCheckInDetail: ${isPermission}`);
    if (isPermission) {
      this.selectedPermissions.push("view_checkin");
      isViewCheckInPagePermission = true;
    }

    isPermission = formValues.isUpdateCheckInDetail;
    console.log(`createUserCheckInPermissionsUpdatePayload, isUpdateCheckInDetail: ${isPermission}`);
    if (isPermission) {
      this.selectedPermissions.push("change_checkin");
      isViewCheckInPagePermission = true;
    }

    if (isViewCheckInPagePermission) {
      this.selectedPermissions.push("view_checkin_page");
    }

    console.log(`createUserCheckInPermissionsUpdatePayload, permissions: ${JSON.stringify(this.selectedPermissions)}`);
    console.log(`createUserCheckInPermissionsUpdatePayload, after adding item, permissions length: ${this.selectedPermissions.length}`);
  }  // end of createUserCheckInPermissionsUpdatePayload

  createUserCheckOutPermissionsUpdatePayload(formValues: any) {
    var isViewCheckOutPagePermission = false;
    var isPermission = false; 
    isPermission = formValues.isViewCheckOutList;
    console.log(`createUserCheckOutPermissionsUpdatePayload, isViewCheckOutList: ${isPermission}`);
    if (isPermission) {
      this.selectedPermissions.push("view_checkout_list");
    }

    isPermission = formValues.isAddCheckOut;
    console.log(`createUserCheckOutPermissionsUpdatePayload, isAddCheckOut: ${isPermission}`);
    if (isPermission) {
      this.selectedPermissions.push("add_checkout");
      isViewCheckOutPagePermission = true;
    }

    isPermission = formValues.isViewCheckOutDetail;
    console.log(`createUserCheckOutPermissionsUpdatePayload, isViewCheckOutDetail: ${isPermission}`);
    if (isPermission) {
      this.selectedPermissions.push("view_checkout");
      isViewCheckOutPagePermission = true;
    }

    isPermission = formValues.isUpdateCheckOutDetail;
    console.log(`createUserCheckOutPermissionsUpdatePayload, isUpdateCheckOutDetail: ${isPermission}`);
    if (isPermission) {
      this.selectedPermissions.push("change_checkout");
      isViewCheckOutPagePermission = true;
    }

    if (isViewCheckOutPagePermission) {
      this.selectedPermissions.push("view_checkout_page");
    }

    console.log(`createUserCheckOutPermissionsUpdatePayload, permissions: ${JSON.stringify(this.selectedPermissions)}`);
    console.log(`createUserCheckOutPermissionsUpdatePayload, after adding item, permissions length: ${this.selectedPermissions.length}`);
  }  // end of createUserCheckOutPermissionsUpdatePayload

  createUserInvoicePermissionsUpdatePayload(formValues: any) {
    var isViewInvoicePagePermission = false;
    var isPermission = false; 
    isPermission = formValues.isViewInvoiceList;
    console.log(`createUserInvoicePermissionsUpdatePayload, isViewInvoiceList: ${isPermission}`);
    if (isPermission) {
      this.selectedPermissions.push("view_invoice_list");
    }

    isPermission = formValues.isAddInvoice;
    console.log(`createUserInvoicePermissionsUpdatePayload, isAddInvoice: ${isPermission}`);
    if (isPermission) {
      this.selectedPermissions.push("add_invoice");
      isViewInvoicePagePermission = true;
    }

    isPermission = formValues.isViewInvoiceDetail;
    console.log(`createUserInvoicePermissionsUpdatePayload, isViewInvoiceDetail: ${isPermission}`);
    if (isPermission) {
      this.selectedPermissions.push("view_invoice");
      isViewInvoicePagePermission = true;
    }

    isPermission = formValues.isUpdateInvoiceDetail;
    console.log(`createUserInvoicePermissionsUpdatePayload, isUpdateInvoiceDetail: ${isPermission}`);
    if (isPermission) {
      this.selectedPermissions.push("change_invoice");
      isViewInvoicePagePermission = true;
    }

    if (isViewInvoicePagePermission) {
      this.selectedPermissions.push("view_invoice_page");
    }

    console.log(`createUserInvoicePermissionsUpdatePayload, permissions: ${JSON.stringify(this.selectedPermissions)}`);
    console.log(`createUserInvoicePermissionsUpdatePayload, after adding item, permissions length: ${this.selectedPermissions.length}`);
  }  // end of createUserInvoicePermissionsUpdatePayload

  createUserExpensePermissionsUpdatePayload(formValues: any) {
    var isViewExpensePagePermission = false;
    var isPermission = false; 
    isPermission = formValues.isViewExpenseList;
    console.log(`createUserExpensePermissionsUpdatePayload, isViewExpenseList: ${isPermission}`);
    if (isPermission) {
      this.selectedPermissions.push("view_expense_list");
    }

    isPermission = formValues.isAddExpense;
    console.log(`createUserExpensePermissionsUpdatePayload, isAddExpense: ${isPermission}`);
    if (isPermission) {
      this.selectedPermissions.push("add_expense");
      isViewExpensePagePermission = true;
    }

    isPermission = formValues.isViewExpenseDetail;
    console.log(`createUserExpensePermissionsUpdatePayload, isViewExpenseDetail: ${isPermission}`);
    if (isPermission) {
      this.selectedPermissions.push("view_expense");
      isViewExpensePagePermission = true;
    }

    isPermission = formValues.isUpdateExpenseDetail;
    console.log(`createUserExpensePermissionsUpdatePayload, isUpdateExpenseDetail: ${isPermission}`);
    if (isPermission) {
      this.selectedPermissions.push("change_expense");
      isViewExpensePagePermission = true;
    }

    if (isViewExpensePagePermission) {
      this.selectedPermissions.push("view_expense_page");
    }

    console.log(`createUserExpensePermissionsUpdatePayload, permissions: ${JSON.stringify(this.selectedPermissions)}`);
    console.log(`createUserExpensePermissionsUpdatePayload, after adding item, permissions length: ${this.selectedPermissions.length}`);
  }  // end of createUserExpensePermissionsUpdatePayload

  createUserUserPermissionsUpdatePayload(formValues: any) {
    var isViewUserPagePermission = false;
    var isPermission = false; 
    isPermission = formValues.isViewUserList;
    console.log(`createUserUserPermissionsUpdatePayload, isViewUserList: ${isPermission}`);
    if (isPermission) {
      this.selectedPermissions.push("view_user_list");
    }

    isPermission = formValues.isAddUser;
    console.log(`createUserUserPermissionsUpdatePayload, isAddUser: ${isPermission}`);
    if (isPermission) {
      this.selectedPermissions.push("add_user");
      isViewUserPagePermission = true;
    }

    isPermission = formValues.isViewUserDetail;
    console.log(`createUserUserPermissionsUpdatePayload, isViewUserDetail: ${isPermission}`);
    if (isPermission) {
      this.selectedPermissions.push("view_user");
      isViewUserPagePermission = true;
    }

    isPermission = formValues.isUpdateUserDetail;
    console.log(`createUserUserPermissionsUpdatePayload, isUpdateUserDetail: ${isPermission}`);
    if (isPermission) {
      this.selectedPermissions.push("change_user");
      isViewUserPagePermission = true;
    }

    isPermission = formValues.isUpdateUserPermission;
    console.log(`createUserUserPermissionsUpdatePayload, isUpdateUserPermission: ${isPermission}`);
    if (isPermission) {
      this.selectedPermissions.push("change_user_permission");
      isViewUserPagePermission = true;
    }

    if (isViewUserPagePermission) {
      this.selectedPermissions.push("view_user_page");
    }

    console.log(`createUserUserPermissionsUpdatePayload, permissions: ${JSON.stringify(this.selectedPermissions)}`);
    console.log(`createUserUserPermissionsUpdatePayload, after adding item, permissions length: ${this.selectedPermissions.length}`);
  }  // end of createUserUserPermissionsUpdatePayload

  createUserQRCodePermissionsUpdatePayload(formValues: any) {
    var isViewQRCodePagePermission = false;
    var isPermission = false; 
    isPermission = formValues.isViewQRCodeList;
    console.log(`createUserQRCodePermissionsUpdatePayload, isViewQRCodeList: ${isPermission}`);
    if (isPermission) {
      this.selectedPermissions.push("view_qrcode_list");
    }

    isPermission = formValues.isAddQRCode;
    console.log(`createUserQRCodePermissionsUpdatePayload, isAddQRCode: ${isPermission}`);
    if (isPermission) {
      this.selectedPermissions.push("add_qrcode");
      isViewQRCodePagePermission = true;
    }

    isPermission = formValues.isViewQRCodeDetail;
    console.log(`createUserQRCodePermissionsUpdatePayload, isViewUserDetail: ${isPermission}`);
    if (isPermission) {
      this.selectedPermissions.push("view_qrcode");
      isViewQRCodePagePermission = true;
    }

    isPermission = formValues.isUpdateQRCodeDetail;
    console.log(`createUserQRCodePermissionsUpdatePayload, isUpdateQRCodeDetail: ${isPermission}`);
    if (isPermission) {
      this.selectedPermissions.push("change_qrcode");
      isViewQRCodePagePermission = true;
    }

    if (isViewQRCodePagePermission) {
      this.selectedPermissions.push("view_qrcode_page");
    }

    console.log(`createUserQRCodePermissionsUpdatePayload, permissions: ${JSON.stringify(this.selectedPermissions)}`);
    console.log(`createUserQRCodePermissionsUpdatePayload, after adding item, permissions length: ${this.selectedPermissions.length}`);
  }  // end of createUserQRCodePermissionsUpdatePayload

  closeModal(result: boolean) {
    this.hideModal(result);
  } // end of closeModal

  hideModal(result: boolean) {
    this.onClose.next(result);
    this.bsModalRef.hide();
  } // end of hideModal

  // Check if a permission is selected
  isSelected(permissionCodeName: string): boolean {
    return this.selectedUser.userPermissions.some(p => p.codename ==permissionCodeName);
  }

  checkPermissions(){
    this.hasEditPermission = this.petService.hasPermission('api.change_user');
    console.log(`UserDetailComponent, hasEditPermission: ${this.hasEditPermission}`);
    this.hasAddPermission = this.petService.hasPermission('api.add_user');
    console.log(`UserDetailComponent, hasAddPermission: ${this.hasAddPermission}`);
    this.hasViewPermission = this.petService.hasPermission('api.view_user');
    console.log(`UserDetailComponent, hasViewPermission: ${this.hasViewPermission}`);
    this.hasEditUserPermissionPermission = this.petService.hasPermission('api.change_user_permission');
    console.log(`UserDetailComponent, hasEditUserPermission: ${this.hasEditUserPermissionPermission}`);
  }

  disableForm(){
    if (!this.hasEditPermission) {
      this.userDetailForm.disable();
    }
  }

  disableField(fieldName: string) {
    this.userDetailForm.get(`${fieldName}`)?.disable();
  }

  disableUserPermissionFields() {
    this.userDetailForm.get('isViewNumberOfOwners')?.disable();
    this.userDetailForm.get('isViewNumberOfPets')?.disable();
    this.userDetailForm.get('isViewNumberOfCheckIns')?.disable();
    this.userDetailForm.get('isViewNumberOfRegistrations')?.disable();
    this.userDetailForm.get('isViewTotalRevenue')?.disable();
    this.userDetailForm.get('isViewDashboard')?.disable();
    this.userDetailForm.get('isViewTotalExpense')?.disable();
    this.userDetailForm.get('isViewTotalIncome')?.disable();
    this.userDetailForm.get('isViewMonthlyRevenue')?.disable();
    this.userDetailForm.get('isViewMonthlyExpense')?.disable();
    this.userDetailForm.get('isViewMonthlyIncome')?.disable();
    this.userDetailForm.get('isViewCurrentYearMonthlyRevenue')?.disable();
    this.userDetailForm.get('isViewCurrentYearMonthlyExpense')?.disable();
    this.userDetailForm.get('isViewCurrentYearMonthlyIncome')?.disable();
    this.userDetailForm.get('isViewPetList')?.disable();
    this.userDetailForm.get('isAddPet')?.disable();
    this.userDetailForm.get('isViewPetDetail')?.disable();
    this.userDetailForm.get('isUpdatePetDetail')?.disable();
    this.userDetailForm.get('isViewOwnerList')?.disable();
    this.userDetailForm.get('isAddOwner')?.disable();
    this.userDetailForm.get('isViewOwnerDetail')?.disable();
    this.userDetailForm.get('isUpdateOwnerDetail')?.disable();
    this.userDetailForm.get('isViewPickUpList')?.disable();
    this.userDetailForm.get('isAddPickUp')?.disable();
    this.userDetailForm.get('isViewPickUpDetail')?.disable();
    this.userDetailForm.get('isUpdatePickUpDetail')?.disable();
    this.userDetailForm.get('isViewCheckInList')?.disable();
    this.userDetailForm.get('isAddCheckIn')?.disable();
    this.userDetailForm.get('isViewCheckInDetail')?.disable();
    this.userDetailForm.get('isUpdateCheckInDetail')?.disable();
    this.userDetailForm.get('isViewCheckOutList')?.disable();
    this.userDetailForm.get('isAddCheckOut')?.disable();
    this.userDetailForm.get('isViewCheckOutDetail')?.disable();
    this.userDetailForm.get('isUpdateCheckOutDetail')?.disable();
    this.userDetailForm.get('isViewInvoiceList')?.disable();
    this.userDetailForm.get('isAddInvoice')?.disable();
    this.userDetailForm.get('isViewInvoiceDetail')?.disable();
    this.userDetailForm.get('isUpdateInvoiceDetail')?.disable();
    this.userDetailForm.get('isViewExpenseList')?.disable();
    this.userDetailForm.get('isAddExpense')?.disable();
    this.userDetailForm.get('isViewExpenseDetail')?.disable();
    this.userDetailForm.get('isUpdateExpenseDetail')?.disable();
    this.userDetailForm.get('isViewUserList')?.disable();
    this.userDetailForm.get('isAddUser')?.disable();
    this.userDetailForm.get('isViewUserDetail')?.disable();
    this.userDetailForm.get('isUpdateUserDetail')?.disable();
    this.userDetailForm.get('isUpdateUserPermission')?.disable();
    this.userDetailForm.get('isViewQRCodeList')?.disable();
    this.userDetailForm.get('isAddQRCode')?.disable();
    this.userDetailForm.get('isViewQRCodeDetail')?.disable();
    this.userDetailForm.get('isUpdateQRCodeDetail')?.disable();
  }

  disableUserDetailsFields() {
    this.userDetailForm.get('branch')?.disable();
    this.userDetailForm.get('firstName')?.disable();
    this.userDetailForm.get('lastName')?.disable();
    this.userDetailForm.get('email')?.disable(); 
  }
}
